import { FormDataModel } from '@/model/FormModel'

export const FromFieldData: FormDataModel[] = [
  {
    title: '基本信息',
    type: 1, // 常规表单
    labelClass: 'blue',
    labelName: '基',
    formList: [
      {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'name',
        fieldName: '公司名称',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'taxId',
        fieldName: '税号',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-tag',
        componentName: '输入框',
        fieldKey: 'taxRate',
        fieldName: '税率',
        placeholder: '请输入税率，单位%',
        value: [],
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          remote: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'maxValueSingleInvoice',
        fieldName: '最大金额',
        placeholder: '单张发票最大金额，单位元',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          remote: false
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'bank',
        fieldName: '开户银行',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'account',
        fieldName: '账号',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'phone',
        fieldName: '电话号码',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'bankCode',
        fieldName: '银行行号',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'fax',
        fieldName: '公司传真',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'registeredAddress',
        fieldName: '注册地址',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          width: '100%'
        }
      }, {
        componentType: 'el-input',
        componentName: '输入框',
        fieldKey: 'officeAddress',
        fieldName: '办公地址',
        placeholder: '',
        value: '',
        rules: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          width: '100%'
        }
      }, {
        componentType: 'el-upload',
        componentName: '输入框',
        fieldKey: 'sealImg',
        fieldName: '印章图片',
        placeholder: '',
        value: '',
        rules: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        config: {
          isDisabled: false,
          clearable: true,
          limit: 1,
          isAvatar: true,
          showFileList: false
        }
      }
    ]
  }
]
